export const mapISODateToString = (date: string) => {
  const isDate: RegExp = /\d{4}-[01]\d-[0-3]\dT[0]\d:[0]\d:[0]\d([+-][0]\d:[0]\d|Z)/
  if (isDate.test(date)) {
    return date.substr(0, 10)
  }

  return date?.split('.')[0].replace('T', ' ').replace('Z', '')
}
